//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS, GameStatus, BetType } from './enum';

import LastWinsCard from './last-wins-card.vue';

export default {
  name: 'LastWins',
  components: {
    LastWinsCard
  },
  props: {
    chickenRoadState: {
      type: Object,
      default: () => ({
        allGames: () => [],
        topGames: () => []
      })
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    },
    currencyType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0,
      isLg: false,
      filterButtons: [
        {
          label: '全部',
          value: 'all',
          icon: 'icon_all'
        },
        {
          label: '最佳',
          value: 'best',
          icon: 'icon_top'
        }
      ]
    };
  },
  computed: {
    displayedGames() {
      if (!this.chickenRoadState) return [];

      if (this.activeIndex === 0) {
        return this.chickenRoadState.allGames || [];
      }

      return this.chickenRoadState.topGames || [];
    }
  },
  mounted() {
    this.checkMediaQuery();
    window.addEventListener('resize', this.checkMediaQuery);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMediaQuery);
  },
  methods: {
    toggleFilter(index) {
      this.activeIndex = index;
    },
    openHistory() {
      if (this.$router) {
        this.$router.push({ name: this.currencyType === 1 ? 'happyCoinChickenRoadHistory' : (this.currencyType === 2 ? 'coin1ChickenRoadHistory' : 'chickenRoadHistory') });
      } else {
        this.$emit('open-history');
      }
    },
    checkMediaQuery() {
      this.isLg = window.innerWidth <= 992;
    }
  }
};
